const QR_MODAL_TERMINAL_STATUSES = new Set([
  "AUTHENTICATED",
  "CONNECTED",
  "DISCONNECTED",
  "TIMEOUT"
]);

export const shouldCloseQrModal = status =>
  QR_MODAL_TERMINAL_STATUSES.has(status);
